var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.936 21.636 2.756 4.91a.85.85 0 0 1-.256-.636.85.85 0 0 1 .257-.637.9.9 0 0 1 .653-.25q.398 0 .654.25l17.18 16.728A.85.85 0 0 1 21.5 21a.85.85 0 0 1-.257.636.9.9 0 0 1-.653.25.9.9 0 0 1-.654-.25M6.118 6.932 7.985 8.75v8.705h8.963l2.241 2.181v.546q0 .75-.548 1.284a1.82 1.82 0 0 1-1.32.534H7.986q-.77 0-1.319-.534a1.73 1.73 0 0 1-.548-1.284zm1.867 12.34v.91h9.337v-.91zM9.83 6.546a.888.888 0 0 1-.91-.91q0-.385.268-.646a.92.92 0 0 1 .666-.262h7.469v-.909H7.518a.92.92 0 0 1-.665-.261.87.87 0 0 1-.268-.648q0-.385.268-.648A.92.92 0 0 1 7.518 2h9.804q.77 0 1.319.534t.548 1.284v10.91q0 .386-.268.647a.92.92 0 0 1-.665.261.92.92 0 0 1-.666-.261.87.87 0 0 1-.268-.648V6.545z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOff);
export default __webpack_public_path__ + "static/media/mobile_off.a0ca34ada43a5751ff1d6b22e4c4cd2d.svg";
export { ForwardRef as ReactComponent };